'use client';

import React, { useRef } from 'react';
import HeroSection from './HeroSection';
import PressKitSection from './PressKitSection';
import PressReleaseSection from './PressReleaseSection';
import MediaContactSection from './MediaContactSection';
import SocialMediaSection from './SocialMediaSection';
import MediaCoverageSection from './MediaCoverageSection';

const MediaCenterInteractive: React.FC = () => {
  const pressKitRef = useRef<HTMLDivElement>(null);
  const mediaContactRef = useRef<HTMLDivElement>(null);

  const scrollToSection = (section: string) => {
    if (section === 'press-kit' && pressKitRef.current) {
      pressKitRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (section === 'media-contact' && mediaContactRef.current) {
      mediaContactRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <HeroSection onScrollToSection={scrollToSection} />
      <div ref={pressKitRef}>
        <PressKitSection />
      </div>
      <PressReleaseSection />
      <div ref={mediaContactRef}>
        <MediaContactSection />
      </div>
      <SocialMediaSection />
      <MediaCoverageSection />
    </>
  );
};

export default MediaCenterInteractive;